import React, { useState, useRef, useEffect } from "react";
import { Box, Typography, Button, Grid, Container } from "@mui/material";
import { styled } from "@mui/system";
import ApartmentIcon from "@mui/icons-material/Apartment";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BusinessIcon from "@mui/icons-material/Business";
import GavelIcon from "@mui/icons-material/Gavel";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import useResponsive from "../../hooks/useResponsive";
import { useNavigate } from "react-router-dom";
// Services data
const services = [
    {
        title: "Search & Shortlisting",
        icon: ApartmentIcon,
        description: "Lacs of verified listings from 500+ reputed developers",
    },
    {
        title: "Site Visit",
        icon: DirectionsCarIcon,
        description: "Guided site visits with our relationship managers",
    },
    {
        title: "Home Loan Assistance",
        icon: BusinessIcon,
        description: "Home loan facilitation through major banks across India",
    },
    {
        title: "Legal Advice",
        icon: GavelIcon,
        description: "Expert legal advice and documentation support",
    },
    {
        title: "Unit Booking",
        icon: VpnKeyIcon,
        description: "Committed guidance all the way till possession",
        whatsapp: true,
        active: true,
    },
];

// Styled components
const IconCircle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active'
})(({ active }) => ({
    width: 100,
    height: 100,
    borderRadius: "50%",
    backgroundColor: active ? "#d50000" : "#f2f2f2",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
    zIndex: 2,
}));

const HorizontalLine = styled(Box)(({ left, width }) => ({
    position: "absolute",
    top: "23%",
    left: `${left}px`,
    width: `${width}px`,
    height: 2,
    backgroundColor: "#d50000",
    zIndex: 1,
    transition: "all 0.7s ease",
}));

// Component
const EndToEndAssistance = () => {
    const navigate = useNavigate();
    const { isSmallScreen } = useResponsive();
    const [hoverIndex, setHoverIndex] = useState(null);
    const containerRef = useRef(null);
    const [lineState, setLineState] = useState({ left: 0, width: 0 });

    const reversedServices = [...services].reverse();

    useEffect(() => {
        if (!containerRef.current || isSmallScreen || hoverIndex === null) return;

        const iconBoxes = containerRef.current.querySelectorAll(".icon-box");
        if (iconBoxes.length === 0) return;

        const containerBox = containerRef.current.getBoundingClientRect();
        const firstBox = iconBoxes[0].getBoundingClientRect();
        const hoverBox = iconBoxes[hoverIndex].getBoundingClientRect();

        // Calculate the starting position of the line (from the first service)
        const startX = firstBox.left - containerBox.left + firstBox.width / 2;
        const endX = hoverBox.left - containerBox.left + hoverBox.width / 2;

        const left = Math.min(startX, endX);
        const width = Math.abs(startX - endX);

        // Ensure the line doesn't go outside the container's width
        const maxWidth = containerBox.width;
        setLineState({ left: Math.max(left, 0), width: Math.min(width, maxWidth) });
    }, [hoverIndex, isSmallScreen]);

    return (
        <Container maxWidth="xl">

            <Box textAlign="center" px={0.3} py={3} position="relative">
                <Typography variant="h4" fontWeight="bold" mb={5}>  End to End Assistance </Typography>

                <Box position="relative" ref={containerRef}>
                    {/* Show red line only on hover */}
                    {!isSmallScreen && hoverIndex !== null && (<HorizontalLine left={lineState.left} width={lineState.width} />)}

                    <Grid container spacing={4} justifyContent="center">
                        {reversedServices.map((service, index) => {
                            const IconComponent = service.icon;
                            const isActive = hoverIndex === index;

                            return (
                                <Grid
                                    key={index} size={{ xs: 12, sm: 6, md: 2.4 }}
                                    onMouseEnter={() => setHoverIndex(index)}
                                    onMouseLeave={() => setHoverIndex(null)}
                                    sx={{ position: "relative", zIndex: 2 }}
                                >
                                    <Box className="icon-box" position="relative" display="flex" flexDirection="column" alignItems="center"  >
                                        <IconCircle active={isActive}> <IconComponent sx={{ fontSize: 40, color: isActive ? "#fff" : "#000", }} />  </IconCircle>

                                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>  {service.title} </Typography>
                                        <Typography variant="body2" color="textSecondary" mb={3} sx={{ maxWidth: 210 }} >  {service.description} </Typography>

                                    </Box>
                                </Grid>

                            );
                        })}
                    </Grid>

                </Box>
                <Button disableRipple disableFocusRipple variant="contained" onClick={() => navigate('/contactus')} color="error"
                    sx={{
                        textTransform: "none", fontWeight: 700,
                        backgroundColor: "#d50000",  color: "#fff", borderColor: "#d50000",

                    }}
                >  Get in Touch
                </Button>
            </Box>
        </Container>
    );
};

export default EndToEndAssistance;
